import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const settingsAutomationRoute: InvariantJiraRoute = {
	name: 'global-automation',
	path: '/jira/settings/automation',
	exact: true,
};
